module.exports = __webpack_public_path__ + "img/bg1.11ecdb2f.jpg";